
import { Provider } from 'react-redux'
import { BrowserRouter, useNavigate } from 'react-router-dom'
import CssBaseline from '@mui/material/CssBaseline'
import { BehaviorSubject } from 'rxjs'
import { switchMap } from 'rxjs/operators'
import { AuthProvider } from 'auth'
import { getAppConfig } from 'app-config'
import rootEffect from '../effects'
import Routes from '../routes'
import { configureStore, epicMiddleware } from '../store'
import GoogleAnalytics4 from '../components/google-analytics4'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

import { ThemeProvider as ThemeProviderV4, ThemeProvider as ThemeProviderV5, StyledEngineProvider } from '@mui/material/styles'
import { themeV4 } from 'theme/v4'
import { themeV5 } from 'theme/v5'
import { generateClassName } from '../../theme/v5/createGenerateClassName'

const { store } = configureStore()

const epic$ = new BehaviorSubject(rootEffect)

const hotReloadingEpic = (...args) =>
  epic$.pipe(switchMap(epic => epic(...args)))

epicMiddleware.run(hotReloadingEpic)

if (module.hot) {
  module.hot.accept('../effects', () => {
    const nextRootEpic = require('../effects').default
    epic$.next(nextRootEpic)
  })
}

const AppWithRouter = () => {
  const navigate = useNavigate()
  const config = getAppConfig()

  const onRedirectCallback = (appState) => {
    navigate(appState?.targetUrl || window.location.pathname, { replace: true })
  }

  return (
    <AuthProvider
      domain={config.auth.domain}
      client_id={config.auth.clientId}
      audience={config.auth.audience}
      redirect_uri={window.location.origin}
      onRedirectCallback={onRedirectCallback}>
      <GoogleAnalytics4 />
      <Routes />
      <CssBaseline />
    </AuthProvider>
  )
}

const App = () => {
  return (
    <Provider store={store}>
      <StyledEngineProvider generateClassName={generateClassName}>
        <ThemeProviderV4 theme={themeV4}>
          <ThemeProviderV5 theme={themeV5}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <BrowserRouter>
                <AppWithRouter />
              </BrowserRouter>
            </LocalizationProvider>
          </ThemeProviderV5>
        </ThemeProviderV4>
      </StyledEngineProvider>
    </Provider>
  )
}

export default App
